import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Garage Kermarec',
    description: "Atelier mécanique indépendant sur l’île de Nantes depuis 2011. Révision, freinage, distribution et pneus à prix affichés, devis écrit avant toute intervention et voiture rendue le jour promis.",
    url: getOrigin()
}

// Image de partage hébergée sur le CDN du site (adresse absolue exigée par Open Graph).
export const SHARE_IMAGE = 'https://garage-kermarec.cdn.modulify.website/images/atelier-pont.jpg'
